import { render, staticRenderFns } from "./Ikns.vue?vue&type=template&id=b0c971c4&scoped=true"
import script from "./Ikns.vue?vue&type=script&lang=js"
export * from "./Ikns.vue?vue&type=script&lang=js"
import style0 from "./Ikns.vue?vue&type=style&index=0&id=b0c971c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c971c4",
  null
  
)

export default component.exports